module.exports = __webpack_public_path__ + "img/5-1-300x233.2f4837c2.png";